module.exports = __webpack_public_path__ + "img/LKW_K_Lkr.2fcd0477.svg";